import axios from 'axios';
import app from "../main";
import {removeStorage} from "../util/storage";
import { getBrowserType } from "../util/common";

axios.defaults.timeout = 15000;
//axios.defaults.baseURL = "http://192.168.10.218:8080/api"; //局域网微信小程序开发工具条数
//axios.defaults.baseURL = "http://localhost:8080/api"; //本地网页调试地址
axios.defaults.baseURL = "https://rfq.anlantech.cn/api"; //正式上线接口地址
axios.defaults.withCredentials = true;
axios.defaults.crossOrigin = '*';

axios.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers['Access-Control-Allow-Headers'] = 'Content-Type';
    return config;
  },
  error => {
    return Promise.reject(error.response);
  }
);

axios.interceptors.response.use(
  response => {
    if (response.data.status===403) {
      removeStorage('rfq_user');
      removeStorage('rfq_admin');
      removeStorage('rfq_privileges');
      app.$message.error({showClose:true,duration:3000,message:response.data.message});
      if(getBrowserType()===1){
        app.$wx.miniProgram.redirectTo({url: '/pages/login/login'})
      }else{
        app.$router.push("/index/login");
      }
      return Promise.reject(response.data);
    }else if(response.data.status!==0){
      if(response.data.status === 4 || response.data.status === 404 || response.data.status === 412) return response.data;
      app.$message.error({showClose:true,duration:3000,message:response.data.message});
      return Promise.reject(response.data);
    }else{
      return response.data;
    }
  },
  error => {
    if(error.response && error.response.data && error.response.data.message){
      app.$message.error({showClose:true,duration:3000,message:error.response.data.message});
    }else{
      app.$message.error({showClose:true,duration:3000,message:error.response.message});
    }
    return Promise.reject(error.response);
  }
);

// 封装自己的get/post方法
export default {
  get: function(path = '/', data = {}) {
    return new Promise(function(resolve, reject) {
      axios.get(path, {
        params: data
      }).then(function(response) {
        resolve(response);
      }).catch(function(error) {
        reject(error);
      });
    });
  },
  post: function(path = '/', data = {}) {
    return new Promise(function(resolve, reject) {
      axios.post(path, data).then(function(response) {
        resolve(response);
      }).catch(function(error) {
        reject(error);
      });
    });
  },
  domain: function(){
    return axios.defaults.baseURL;
  },
  setCookie: function(cookie){
    this.get('/user/cookie/set?'+cookie);
  }
};



// WEBPACK FOOTER //
// ./src/api/request.js